import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import type { APlusContentModule } from "reedy-data/api";
import { Text } from "components/text";
import { capitalizeFirstLetter } from "utils/helpers";

interface APlusModuleListProps {
  modules: APlusContentModule[];
  footer?: ReactNode;
}

export const formatAPlusModuleType = (type: string): string => {
  const pascal = type
    .split("_")
    .filter(Boolean)
    .map(capitalizeFirstLetter)
    .join("");

  return pascal.endsWith("Module") ? pascal : `${pascal}Module`;
};

export const APlusModuleList = ({ modules, footer }: APlusModuleListProps) => {
  const { t } = useTranslation(["productDetails"]);

  return (
    <div className="w-full max-w-sm rounded-md border border-secondary-200 bg-secondary-50 px-4 py-3">
      <ul
        className="flex flex-col items-center gap-1"
        aria-label={t("productDetails:aPlusContent.moduleListLabel")}
      >
        {modules.map((module) => {
          const type = formatAPlusModuleType(module.type);

          return (
            <li key={module.type} data-module-type={type}>
              <Text variant="body" numeric="tabular">
                {t("productDetails:aPlusContent.moduleRow", {
                  count: module.count,
                  type,
                })}
              </Text>
            </li>
          );
        })}
      </ul>
      {footer ? <div className="mt-3">{footer}</div> : null}
    </div>
  );
};
